<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["data", "options"],
  mounted() {
    this.renderLineChart();
  },
  computed: {
    datasets: function() {
      let result = [];
      this.data.datasets.forEach(function(element) {
        result.push(element.data);
      });
      //result.push(this.data.labels);
      return result;
    }
  },
  methods: {
    renderLineChart: function() {
      this.renderChart(this.data, this.options);
    }
  },
  watch: {
    datasets: function() {
      this.renderLineChart();
    }
  }
};
</script>
